import { ContextSystemProvider } from '@wp-g2/context';
import React from 'react';
var contextValue = {
  Text: {
    variant: 'muted'
  }
};

function FormGroupHelp(_ref) {
  var children = _ref.children;
  if (!children) return null;
  return /*#__PURE__*/React.createElement(ContextSystemProvider, {
    value: contextValue
  }, children);
}

export default /*#__PURE__*/React.memo(FormGroupHelp);